import * as moment from 'moment';
import data from '../../../data/early_voting_data.json';
// import countyHistorical from '../../../data/counties.json';

// get latest date
let momentDates = Object.keys(data[0].results).map(d => moment(d)),
  maxDate = moment.max(momentDates);

// latest cumulative data
let latestData = data[0].results[maxDate.format('YYYY-MM-DD HH:mm:ss.S')],
  latestCumulativeVotes =
    latestData.county_results['TOTAL']['cumulative_votes_in_person_and_mail'],
  latestCumulativeRegVoters =
    latestData.county_results['TOTAL']['registered_voters'];

// cumulative registered voters across parties
let totalCumulativeRegVoters = parseFloat(
  latestCumulativeRegVoters.replace(/,/g, '')
);

// cumulative votes across parties
let totalCumulativeVotes = parseFloat(latestCumulativeVotes.replace(/,/g, ''));

// first day of early voting + how many days of results we have
let firstDayEarlyVoting = moment.min(momentDates),
  numberOfDaysResults = maxDate.diff(firstDayEarlyVoting, 'days') + 1;

// get top 15 counties with the most registered voters from this year's data
let top15Counties = Object.keys(latestData.county_results)
  .sort(function(a, b) {
    return (
      latestData.county_results[b].registered_voters -
      latestData.county_results[a].registered_voters
    );
  })
  .slice(0, 15);

// get top 15's latest data
let top15 = top15Counties.map(c => latestData.county_results[c]),
  top15CumulativeVotes = top15 // get total votes from the top 15 counties
    .map(d =>
      parseFloat(d.cumulative_votes_in_person_and_mail.replace(/,/g, ''))
    )
    .reduce((a, b) => a + b, 0);

// get top 10 counties with the most registered voters from this year's data
let top10Counties = Object.keys(latestData.county_results)
  .sort(function(a, b) {
    return (
      latestData.county_results[b].registered_voters -
      latestData.county_results[a].registered_voters
    );
  })
  .slice(0, 10);

// get top 10's latest data
let top10 = top10Counties.map(c => latestData.county_results[c]),
  top10CumulativeVotes = top10 // get total votes from the top 10 counties
    .map(d =>
      parseFloat(d.cumulative_votes_in_person_and_mail.replace(/,/g, ''))
    )
    .reduce((a, b) => a + b, 0),
  top10totalCumulativeRegVoters = top10 // get total registered voters from the top 10 counties
    .map(d => parseFloat(d.registered_voters.replace(/,/g, '')))
    .reduce((a, b) => a + b, 0);

// // get top 15's historical data
// let top15Historical = countyHistorical[`day_${numberOfDaysResults}`].filter(c =>
//   top15Counties.includes(c.name.toUpperCase())
// );

// // get top 15's 2016 and 2012 data
// let top15CumulativeVotes2016 = top15Historical.reduce((a, b) => {
//   if (!b['2016_votes_dem'] || b['2016_votes_dem'] == '') {
//     return a + 0;
//   } else {
//     return a + b['2016_votes_dem'];
//   }
// }, 0);

// let top15CumulativeVotes2012 = top15Historical.reduce((a, b) => {
//   if (!b['2012_votes_dem'] || b['2012_votes_dem'] == '') {
//     return a + 0;
//   } else {
//     return a + b['2012_votes_dem'];
//   }
// }, 0);

export {
  maxDate,
  latestCumulativeVotes,
  totalCumulativeVotes,
  totalCumulativeRegVoters,
  numberOfDaysResults,
  firstDayEarlyVoting,
  top15CumulativeVotes,
  top10CumulativeVotes,
  top10totalCumulativeRegVoters,
  // top15CumulativeVotes2016,
  // top15CumulativeVotes2012,
};
